import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

import LogIn from "./views/LogIn";
import SignIn from "./views/SignIn";

const Routing = () => {
  return (
    <Router>
      <Routes>
        <Route exact path="/login" element={<LogIn />} />
        <Route exact path="/signin" element={<SignIn />} />
      </Routes>
    </Router>
  );
};

export default Routing;
